module.exports = __webpack_public_path__ + "img/product_1.b5242c2a.png";